﻿import React from 'react';
import IconHelper from '@bazooka_se/lf-icons';

//lib
import { AnimatePresence, motion } from "framer-motion";


const BasicInsuranceCoverListItem = ({ id, combined, expanded, setExpanded, ind }) => {

    const [meta, setMeta] = React.useState([]);

    const ref = React.useRef();

    React.useEffect(() => {
        if (combined.metaData.length > 0) {
            setMeta(combined.metaData[0]);
        }     
    }, [combined.metaData])


    const isOpen = ind === expanded;


    return (
 
        <li className="teaser-basic-insurance">
  
            <motion.header
                className={`teaser-basic-insurance__content ${isOpen ? "teaser-basic-insurance__content--expanded" : ""}`}
                onClick={() => setExpanded(isOpen ? false : ind)}>

                <h3 className="teaser-basic-insurance__content__heading">{ meta.groupDisplayName }</h3>

                <div className="teaser-basic-insurance__content__pricing">
                    <p>fr.
                        <span className="bold">{ combined.quote }kr / månad</span><span className="separator"></span>
                     
                    </p>
                    <div className="icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('angle-down').outerHTML }}>
                    </div>
                </div>
            </motion.header>

            <AnimatePresence
                initial={false}>

                {isOpen && (
                <motion.div
                        className="teaser-basic-insurance__additional-info"
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={{
                            open: { opacity: 1, height: "auto" },
                            closed: { opacity: 0, height: 0 },
                        }}
                        transition={{ duration: 0.8 }}>

                    <div className="teaser-basic-insurance__additional-info__content" ref={ref}>

                        <h4 className="teaser-basic-insurance__additional-info__content__title" >Fördelar med försäkringen</h4>

                        {meta.insuranceShortInfo !== null &&
                            <div dangerouslySetInnerHTML={{ __html: meta.insuranceShortInfo }}></div>
                        }
                        <div className="teaser-basic-insurance__additional-info__content__links">
                            <a className="link arrow-link" href={meta.insurancePageLinkUrl }>
                                Läs mer om försäkringen
                                <span
                                    className="icon"
                                    dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}>
                                </span>
                            </a>
                       
                            <a className="button button--green button--small"
                                href={ meta.insurancePurchaseLinkUrl }>Köp försäkring
                            </a>
                        </div>
                    </div>
                </motion.div>
                )}
            </AnimatePresence>

            <div className="teaser-basic-insurance__footer">
                <p className="teaser-basic-insurance__footer__notice">
                    <span
                        className="icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('info-circle').outerHTML }}>
                    </span>
                    Du saknar denna försäkring
                </p>

                <a className="button button--green button--small"
                    href={ meta.insurancePurchaseLinkUrl }>Köp försäkring
                </a>
            </div>
 
        </li>

    )
}


export default BasicInsuranceCoverListItem;